// extracted by mini-css-extract-plugin
module.exports = {"Filters":"ShipmentsExplorer_Filters__aBngu","Active":"ShipmentsExplorer_Active__3dY5c"};